import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';

import BaseLink from '@/components/core/Link';
import { Text } from '@/ui/Text';

const HeaderLogo = ({ href }: { href: string }) => {
	const { t } = useTranslation();

	return (
		<div className="flex items-center space-x-5 flex-shrink-0">
			<div className="min-w-[60px]">
				<BaseLink
					href={href}
					aria-label={`${t('layout.title')}, ${t('accessibility.main')}`}>
					<Image
						src="/img/svg/logo.svg"
						width={125}
						height={80}
						alt={t('layout.title')} />
				</BaseLink>
			</div>
			<div className="max-[1200px]:hidden py-5">
				<Text variant="header4" className="text-base">
					{t('layout.title')}
				</Text>
			</div>
		</div>
	);
};

export { HeaderLogo };
